export function getLastTimeOfDay(dateInput: Date) {
  const date = new Date(dateInput);
  date.setUTCHours(23, 59, 59, 999);
  date.setUTCDate(date.getUTCDate());

  return date.toISOString().split("T").join(" ").slice(0, 19);
}

export function getStartTimeOfDay(dateInput: Date) {
  const date = new Date(dateInput);
  date.setUTCHours(0, 0, 0, 0);
  date.setUTCDate(date.getUTCDate());

  return date.toISOString().split("T").join(" ").slice(0, 19);
}

export function currentDateTime() {
  const date = new Date();
  date.setUTCHours(23, 59, 59, 999);
  date.setUTCDate(date.getUTCDate());

  return date.toISOString().split("T").join(" ").slice(0, 19);
}

export function getDomainWithoutSubdomain(url: string) {
  try {
    const urlParts = new URL(url).hostname.split(".");
    return urlParts
      .slice(0)
      .slice(-(urlParts.length === 4 ? 3 : 2))
      .join(".");
  } catch (error) {
    console.log("55", error);
    return "";
  }
}
